var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('span',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('button',{on:{"click":_vm.click}},[_vm._v("CLICK")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t"+_vm._s(_vm.newTest)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3475e1ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = null
// module chunks = 